module.exports = __webpack_public_path__ + "img/Ajustes.e074e3a7.svg";